export default {
  HOME: "Home",
  CAMPAIGN_LIST: "Campaigns",
  CAMPAIGN_DETAIL: "Campaign",
  FORCE_LIST: "Forces",
  FORCE_DETAIL: "Force",
  CARD_DETAIL: "Card",
  COMBAT_TALLY_DETAIL: "Combat Tally",
};
